import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
    onReset: () => void;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
    // Manual typings to satisfy strict/missing type environments
    state: State = {
        hasError: false,
        error: null
    };
    props: Props;

    constructor(props: Props) {
        super(props);
        this.props = props;
    }

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="fixed inset-0 bg-slate-950 flex items-center justify-center p-6 z-[9999]">
                    <div className="bg-slate-900 border border-red-500/30 p-8 rounded-2xl max-w-md w-full text-center shadow-2xl">
                        <div className="text-4xl mb-4">💥</div>
                        <h2 className="text-xl font-black text-white mb-2 uppercase tracking-tight">Kritischer Fehler</h2>
                        <p className="text-slate-400 text-sm mb-6">
                            Die Anwendung ist abgestürzt. Das liegt meistens an veralteten Daten im Browser-Cache.
                        </p>
                        <div className="bg-red-950/30 p-3 rounded border border-red-900/50 text-red-400 text-[10px] font-mono mb-6 overflow-hidden truncate block text-left">
                            {this.state.error?.message}
                        </div>
                        <button
                            onClick={() => {
                                this.props.onReset();
                                (this as any).setState({ hasError: false, error: null });
                            }}
                            className="w-full py-3 bg-red-600 hover:bg-red-700 text-white font-black uppercase tracking-widest rounded-xl shadow-lg transition-transform active:scale-95 text-xs"
                        >
                            App Zurücksetzen (Logout)
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
